import { useMsTeamsSelector, useTranslate } from "front";
import { translations } from "../../translations";

export const useContactTabs = () => {
  const t = useTranslate(translations);
  const { isLightTheme } = useMsTeamsSelector("isLightTheme");

  return { t, isLightTheme };
};
